module.exports = __webpack_public_path__ + "static/media/shark.c6e3f8c1.svg";